import { Route, Routes } from "react-router-dom"
import Footer from "../components/footer/Footer"
import Header from "../components/header/Header"
//import SidebarLogin from "../components/sidebar/SidebarLogin"
import RouterHomeIn from "./RouterHomeIn"
import RouterHomeOut from "./RouterHomeOut"

const RouterMain = () => {
    return (
        <>
            <Header />

            <Routes>
                <Route path="/ecosistema/*" element={<RouterHomeIn />} />
                <Route path="/*" element={<RouterHomeOut />} />
            </Routes>

            <Footer />
        </>
    )
}

export default RouterMain